import { Box, Tooltip } from '@parspec/pixel';

interface RowContainerProps {
    children: React.ReactNode;
    forSkeleton?: boolean;
    isLastRow?: boolean;
    rowTooltip?: string;
}
export function RowContainer({ children, forSkeleton = false, isLastRow = false, rowTooltip }: RowContainerProps) {
    return (
        <>
            <Tooltip title={rowTooltip || ''} PopperProps={{ sx: { '& .MuiTooltip-tooltip': { maxWidth: '473px', textAlign: 'center' } } }} arrow>
                <Box display="flex" alignItems="center" mb={isLastRow ? 0 : 4} pt={forSkeleton ? '0px' : '10px'}>
                    {children}
                </Box>
            </Tooltip>
        </>
    );
}
